/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, EmbeddedViewRef, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef} from '@angular/core';
/**
 * \@ngModule CommonModule
 * 
 * \@whatItDoes Inserts an embedded view from a prepared `TemplateRef`
 * 
 * \@howToUse 
 * ```
 * <ng-container *ngTemplateOutlet="templateRefExp; context: contextExp"></ng-container>
 * ```
 * 
 * \@description 
 * 
 * You can attach a context object to the `EmbeddedViewRef` by setting `[ngTemplateOutletContext]`.
 * `[ngTemplateOutletContext]` should be an object, the object's keys will be available for binding
 * by the local template `let` declarations.
 * 
 * Note: using the key `$implicit` in the context object will set it's value as default.
 * 
 * ## Example
 * 
 * {\@example common/ngTemplateOutlet/ts/module.ts region='NgTemplateOutlet'}
 * 
 * \@experimental
 */
export class NgTemplateOutlet implements OnChanges {
private _viewRef: EmbeddedViewRef<any>;
public ngTemplateOutletContext: Object;
public ngTemplateOutlet: TemplateRef<any>;
/**
 * @param {?} _viewContainerRef
 */
constructor(private _viewContainerRef: ViewContainerRef) {}
/**
 * @deprecated v4.0.0 - Renamed to ngTemplateOutletContext.
 * @param {?} context
 * @return {?}
 */
set ngOutletContext(context: Object) { this.ngTemplateOutletContext = context; }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges) {
    if (this._viewRef) {
      this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._viewRef));
    }

    if (this.ngTemplateOutlet) {
      this._viewRef = this._viewContainerRef.createEmbeddedView(
          this.ngTemplateOutlet, this.ngTemplateOutletContext);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngTemplateOutlet]'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngTemplateOutletContext': [{ type: Input },],
'ngTemplateOutlet': [{ type: Input },],
'ngOutletContext': [{ type: Input },],
};
}

function NgTemplateOutlet_tsickle_Closure_declarations() {
/** @type {?} */
NgTemplateOutlet.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgTemplateOutlet.ctorParameters;
/** @type {?} */
NgTemplateOutlet.propDecorators;
/** @type {?} */
NgTemplateOutlet.prototype._viewRef;
/** @type {?} */
NgTemplateOutlet.prototype.ngTemplateOutletContext;
/** @type {?} */
NgTemplateOutlet.prototype.ngTemplateOutlet;
/** @type {?} */
NgTemplateOutlet.prototype._viewContainerRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/common/src/directives/ng_template_outlet.ts